module.exports = __webpack_public_path__ + "img/handmaster.1ec6fbe0.png";